export default "__VITE_ASSET__fff38790__"